/**

Coded by www.techhighway.ca

*/

import { Link, useLocation, useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import Icon from "@mui/material/Icon";
import { NA } from "components/Icon/Call";
import customAlert from "components/MDAlert/customAlert";
import MDBox from "components/MDBox";
import MDSwitch from "components/MDSwitch";
import MDTypography from "components/MDTypography";
import { PreserveTable, useCache } from "context";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import AgentsService from "services/agent-service";
import authPermission from "utility/auth-permissions";
import { formatPhone, ucWords } from "utility/helpers";
export default function data(props) {
  const { hasPermission } = authPermission();
  const pagePermission = hasPermission("/manage-agents");
  const preserveTable = useContext(PreserveTable);
  const { page_no, page_size, sort_column, sort_column_value, search_value } =
    preserveTable?.agent;
  const { openAlertSB, closeAlertSB, renderAlertSB } = customAlert();
  const [agentsData, setAgentsData] = useState([]);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = React.useState("");
  const [totalData, setTotalData] = useState(0);
  const { cacheItems, setCacheItems } = useCache();
  const [isData, setIsData] = useState(false);
  const location = useLocation();

  const handleClickOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (location?.state?.color) {
      openAlertSB(location?.state);
      setTimeout(function () {
        closeAlertSB();
      }, 3000);
    }
  }, []);

  const getData = async (page_no, page_size, sortColumn, sortColumnValue, searchWord) => {
    const preserveData = {
      page_no,
      page_size,
      sort_column: sortColumn,
      sort_column_value: sortColumnValue,
      search_value: searchWord,
    };
    preserveTable.setPreserveAgent(preserveData);
    const response = await AgentsService.getAgents(
      page_no,
      page_size,
      sortColumn,
      sortColumnValue,
      searchWord
    );
    setAgentsData(response?.data);
    setTotalData(response?.total);
    setIsData(true);
  };

  const updateActiveAgent = async (id, status) => {
    try {
      const data = { active: status };
      const res = await AgentsService.updateActiveAgent(id, data);
      if (res) {
        if (cacheItems.hasOwnProperty("agents")) {
          // Create a new object without the key
          const { agents, ...rest } = cacheItems; // Destructure to exclude key
          setCacheItems(rest); // Set the new cache items without key
        }
        openAlertSB({ color: "success", icon: "check", msg: res, title: "Agent" });
        setTimeout(function () {
          closeAlertSB();
        }, 3000);
        const response = await AgentsService.getAgents(
          page_no,
          page_size,
          sort_column,
          sort_column_value,
          search_value
        );
        setAgentsData(response?.data);
        setTotalData(response?.total);
      }
    } catch (res) {
      if (res.hasOwnProperty("message")) {
        openAlertSB({ color: "error", icon: "warning", msg: res.message, title: "Agent" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      } else {
        openAlertSB({
          color: "error",
          icon: "warning",
          msg: res.errors[0].detail,
          title: "Agent",
        });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    }
  };

  const deleteAgent = async (id) => {
    try {
      const response = await AgentsService.deleteAgent(id);
      if (response) {
        if (cacheItems.hasOwnProperty("agents")) {
          // Create a new object without the key
          const { agents, ...rest } = cacheItems; // Destructure to exclude key
          setCacheItems(rest); // Set the new cache items without key
        }
        openAlertSB({ color: "success", icon: "check", msg: response, title: "Agent" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    } catch (res) {
      if (res.hasOwnProperty("message")) {
        openAlertSB({ color: "error", icon: "warning", msg: res.message, title: "Agent" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      } else {
        openAlertSB({
          color: "error",
          icon: "warning",
          msg: res.errors[0].detail,
          title: "Agent",
        });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    }
    const res = await AgentsService.getAgents(
      page_no,
      page_size,
      sort_column,
      sort_column_value,
      search_value
    );
    setAgentsData(res?.data);
    setTotalData(res?.total);
    setSelectedId("");
    handleClose();
  };

  const allRows = [];
  agentsData?.map((eachAgent, index) => {
    const eachData = {
      id: (
        <MDTypography
          component={Link}
          to={pagePermission.edit ? `/manage-agents/edit?id=${eachAgent.id}` : ""}
          variant="body2"
          color="text"
        >
          {eachAgent.id}
        </MDTypography>
      ),
      name: (
        <MDTypography
          color="info"
          component={Link}
          to={pagePermission.edit ? `/manage-agents/edit?id=${eachAgent.id}` : ""}
          variant="body2"
          sx={{ whiteSpace: 'nowrap' }}
        >
          {eachAgent.name}
        </MDTypography>
      ),
      client: (
        eachAgent.client ? 
          <MDTypography
            color="info"
            component={Link}
            to={pagePermission.edit ? `/manage-clients/edit?id=${eachAgent.client.id}` : ""}
            variant="body2"
            sx={{ whiteSpace: 'nowrap' }}
          >
            {eachAgent.client.name}
          </MDTypography>
          : <NA />
      ),
      model: (
        <MDTypography display="block" variant="body2">
          {ucWords(eachAgent.model)}
        </MDTypography>
      ),
      transcriber: (
        <MDTypography display="block" variant="body2">
          {ucWords(eachAgent.transcriber_model)}
        </MDTypography>
      ),
      voice: (
        <MDTypography display="block" variant="body2">
          {ucWords(eachAgent.voice_id)}
        </MDTypography>
      ),
      phone: (
        <MDTypography display="block" variant="body2" sx={{ whiteSpace: 'nowrap' }}>
          {formatPhone(eachAgent.phone) || <NA />}
        </MDTypography>
      ),
      action: (
        <MDBox display="flex">
          {/* {<CallButton size="sm" agent_api_id={eachAgent.api_id} />} */}
          {pagePermission.status ? (
            <MDSwitch
              checked={!!eachAgent.active}
              color="info"
              title="Active Status"
              onChange={() => updateActiveAgent(eachAgent.id, !eachAgent.active)}
            />
          ) : (
            ""
          )}
          {pagePermission.edit ? (
            <MDTypography
              mr={1}
              mt={1}
              component={Link}
              to={`/manage-agents/edit?id=${eachAgent.id}`}
              title="Edit"
              display="block"
              variant="body2"
              color="info"
            >
              <Icon fontSize="small">edit</Icon>
            </MDTypography>
          ) : (
            ""
          )}
          {pagePermission.new ? (
            <MDTypography
              mr={1}
              mt={1}
              component={Link}
              to={`/manage-agents/add?id=${eachAgent.id}`}
              title="Copy"
              display="block"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              <Icon fontSize="small">content_copy_icon</Icon>
            </MDTypography>
          ) : (
            ""
          )}
          {pagePermission.remove ? (
            <MDTypography
              mt={1}
              component={Link}
              onClick={() => handleClickOpen(eachAgent.id)}
              title="Remove"
              display="block"
              variant="body2"
              color="error"
            >
              <Icon fontSize="small">delete</Icon>
            </MDTypography>
          ) : (
            ""
          )}
          {renderAlertSB}
        </MDBox>
      ),
    };
    allRows[index] = eachData;
  });

  return {
    columns: [
      { Header: "Id", accessor: "id", align: "left" },
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "Client", accessor: "client", align: "left" },
      { Header: "Model", accessor: "model", align: "left" },
      { Header: "Transcriber", accessor: "transcriber", align: "left" },
      { Header: "Voice", accessor: "voice", align: "left" },
      { Header: "Phone", accessor: "phone", align: "left" },
      ...(pagePermission.status || pagePermission.edit || pagePermission.remove
        ? [{ Header: "actions", accessor: "action", width: "2%", align: "center" }]
        : []),
    ],
    rows: allRows,
    open,
    handleClickOpen,
    handleClose,
    deleteAgent,
    selectedId,
    totalData,
    page: page_no,
    pageSize: page_size,
    getData,
    sortColumn: sort_column,
    sortColumnValue: sort_column_value,
    searchValue: search_value,
    pagePermission,
    isData: isData,
  };
}
